<template>
  <div>
    <p>
      {{ $t('other') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OtherError',
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
other: Your camera is unavailable. Please try another device.
</i18n>

<i18n locale="ru" lang="yaml">
other: Ваша камера недоступна. Воспользуйтесь другим устройством.
</i18n>
